(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["make-it-a-set"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__caMakeItASet) return;
    window.__caMakeItASet = true;
    function root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }
    function addLines(items) {
      return fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
    }

    // Product page: ticked add-ons go in the cart first, then the normal Add to cart runs.
    // On window, not document: Horizon's own submit listener sits on document (capture) and this bundle loads
    // after it, so only a window listener is sure to run first and hold the theme's add until the add-ons are in.
    window.addEventListener('submit', async function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.closest('product-form-component')) return;
      var details = form.closest('.product-details');
      var box = details && details.querySelector('.ca-set');
      if (!box) return;
      if (form.dataset.caSetPass === '1') { form.dataset.caSetPass = ''; return; }
      if (form.dataset.caSetBusy === '1') { event.preventDefault(); event.stopImmediatePropagation(); return; }
      var checked = Array.prototype.slice.call(box.querySelectorAll('.ca-set__check:checked'));
      if (!checked.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      form.dataset.caSetBusy = '1';
      try {
        var res = await addLines(checked.map(function (c) { return { id: Number(c.value), quantity: 1 }; }));
        if (!res.ok) console.warn('Make it a set: add-ons not added', await res.text());
      } catch (err) {
        console.warn('Make it a set:', err);
      }
      checked.forEach(function (c) { c.checked = false; });
      form.dataset.caSetBusy = '';
      form.dataset.caSetPass = '1';
      form.requestSubmit();
    }, true);

    // "Learn more" slide-out. A modal <dialog>, so it also sits above the quick-add popup.
    function checkFor(dialog) {
      var box = dialog.closest('.ca-set');
      return box && box.querySelector('.ca-set__check[value="' + dialog.dataset.caSetDrawer + '"]');
    }
    function openDrawer(button) {
      var box = button.closest('.ca-set');
      var dialog = box && box.querySelector('dialog[data-ca-set-drawer="' + button.dataset.caSetMore + '"]');
      if (!dialog || dialog.open) return;
      var check = checkFor(dialog);
      var pick = dialog.querySelector('[data-ca-set-pick]');
      if (pick) pick.textContent = check && check.checked ? 'Take out of my set' : 'Add to my set';
      dialog.showModal();
      document.documentElement.classList.add('ca-set-lock');
      // a timer, not requestAnimationFrame: rAF is paused in background tabs
      setTimeout(function () { dialog.classList.add('is-open'); }, 20);
    }
    function closeDrawer(dialog) {
      if (!dialog.open) return;
      dialog.classList.remove('is-open');
      setTimeout(function () { if (dialog.open) dialog.close(); }, 280);
    }
    document.addEventListener('click', function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      var more = target.closest('[data-ca-set-more]');
      if (more) { event.preventDefault(); openDrawer(more); return; }
      var dialog = target.closest('dialog.ca-set-drawer');
      if (!dialog) return;
      if (target === dialog || target.closest('[data-ca-set-close]')) { closeDrawer(dialog); return; }
      if (target.closest('[data-ca-set-pick]')) {
        var check = checkFor(dialog);
        if (check) {
          check.checked = !check.checked;
          check.dispatchEvent(new Event('change', { bubbles: true }));
        }
        closeDrawer(dialog);
      }
    });
    // Esc slides it out instead of making it vanish
    document.addEventListener('cancel', function (event) {
      var dialog = event.target;
      if (dialog instanceof HTMLDialogElement && dialog.classList.contains('ca-set-drawer')) {
        event.preventDefault();
        closeDrawer(dialog);
      }
    }, true);
    document.addEventListener('close', function (event) {
      var dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement) || !dialog.classList.contains('ca-set-drawer')) return;
      if (!document.querySelector('dialog.ca-set-drawer[open]')) document.documentElement.classList.remove('ca-set-lock');
    }, true);

    // Cart drawer and cart page suggestions (snippets/ca-cart-set.liquid): add without leaving the page,
    // then tell the theme the cart changed so the drawer, cart page and cart count refresh.
    document.addEventListener('submit', async function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.classList.contains('ca-cartset__form')) return;
      event.preventDefault();
      var button = form.querySelector('button[type="submit"]');
      if (button) {
        if (button.disabled) return;
        button.disabled = true;
      }
      var id = form.elements.id.value;
      var added = false;
      try {
        var res = await addLines([{ id: Number(id), quantity: 1 }]);
        if (!res.ok) throw new Error(await res.text());
        added = true;
        var events = await import('@shopify/events');
        var cart = await fetch(root() + 'cart.js').then(function (r) { return r.json(); });
        var deferred = events.CartLinesUpdateEvent.createPromise();
        form.dispatchEvent(
          new events.CartLinesUpdateEvent({
            action: 'add',
            context: 'cart',
            lines: [{ merchandiseId: String(id), quantity: 1 }],
            promise: deferred.promise
          })
        );
        deferred.resolve({
          cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'ca-cart-set', itemCount: 1, didError: false }
        });
      } catch (err) {
        console.warn('Make it a set:', err);
        if (added) window.location.reload();
        else form.submit();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
